



















































import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';

import Product from '@/classes/Product';
import IdBadge from '@/components/Misc/IdBadge.vue';
import PricePresenter from '@/components/Misc/PricePresenter.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
import { ITag, IVariance } from '@/interfaces';
import { upsertList } from '@/main';
import ProductsModule from '@/store/modules/ProductsModule';

const productsModule = getModule(ProductsModule);

export default Vue.extend({
  components: {
    IdBadge,
    PricePresenter,
    TagBadge,
  },
  props: ['isEditing', 'originalCopy'],
  data() {
    return {
      panel: [] as boolean[],
      activeTab: '',
      workingCopy: _.cloneDeep(this.originalCopy), // this.cloneForForm(this.originalCopy),
      newTagText: '',
      submitError: '',
    };
  },
  methods: {
    cancel() {
      if (confirm('確定要取消?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
        this.$emit('cancel');
      }
    },
    save() {
      productsModule.apiUpdateProduct({ product: this.workingCopy }).then((response) => {
        if (response.success === false) {
          this.submitError = response.error.message;
          return;
        }
        this.$emit('saved');
      });
    },
    reset() {
      if (confirm('確定要重置?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
      }
    },
    addVariance() {
      this.workingCopy.variances.push({
        iscreate: true,
        productid: this.workingCopy.productid,
      } as IVariance);
      this.panel[this.workingCopy.variances.length - 1] = true;
    },
  },
});
